<template>
  <v-row>
    <v-col cols="12" sm="6" md="3">
      <statistics-card-vertical :is-loading="areExercisesLoading" :statistic-value="fitnessExercises.length"
                                :icon="icons.mdiWeightLifter" title="Fitness Exercises" color="success"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <statistics-card-vertical :is-loading="areExercisesLoading" :statistic-value="practiceDrills.length"
                                :icon="icons.mdiWeightLifter" title="Practice Drills" color="success"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <statistics-card-vertical :is-loading="areFitnessRoutinesLoading" :statistic-value="fitnessRoutines.length"
                                :icon="icons.mdiAvTimer" title="Fitness Routines" color="success"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <statistics-card-vertical :is-loading="arePracticeSessionsLoading" :statistic-value="practiceSessions.length"
                                :icon="icons.mdiFileChartOutline" title="Practice Sessions" color="success"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <statistics-card-vertical :is-loading="areFitnessAssessmentsLoading || areSessionAssessmentsLoading"
                                :statistic-value="fitnessSessionAssessments.length" :icon="icons.mdiDumbbell" title="Fitness Assessments"
                                color="info"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <statistics-card-vertical :is-loading="areGolfAssessmentsLoading || areSessionAssessmentsLoading"
                                :statistic-value="golfSkillsSessionAssessments.length" :icon="icons.mdiGolfTee" title="Golf Skills Assessments"
                                color="info"
      />
    </v-col>
  </v-row>
</template>

<script>
import {
  mdiAvTimer, mdiDumbbell, mdiGolfTee, mdiWeightLifter, mdiFileChartOutline,
} from '@mdi/js'
import StatisticsCardVertical from '@/components/statisticCards/StatisticsCardVertical.vue'
import useExercises from '@/composables/api/exercises'
import useSessions from '@/composables/api/sessions'
import useFitnessAssessments from '@/composables/api/assessments/fitness'
import useGolfAssessments from '@/composables/api/assessments/golf'
import useSessionAssessments from '@/composables/api/assessments/session'
import { ref, onMounted, computed } from 'vue'

export default {
  components: {
    StatisticsCardVertical,
  },

  setup() {
    const { exercises, isLoading: areExercisesLoading, fetchExercises } = useExercises()
    const { sessions, isLoading: areSessionsLoading, fetchSessions } = useSessions()
    const { fitnessAssessments, isLoading: areFitnessAssessmentsLoading, fetchFitnessAssessments } = useFitnessAssessments()
    const { golfAssessments, isLoading: areGolfAssessmentsLoading, fetchGolfAssessments } = useGolfAssessments()
    const { sessionAssessments, isLoading: areSessionAssessmentsLoading, fetchSessionAssessments } = useSessionAssessments()

    const fitnessExercises = ref([])
    const practiceDrills = ref([])
    const fitnessRoutines = computed(() => sessions.value.filter(session => session.category === 'fitness'))
    const practiceSessions = computed(() => sessions.value.filter(session => session.category === 'practice'))
    const fitnessSessionAssessments = computed(() => sessionAssessments.value.filter(a => a.category && a.category.toLowerCase() === 'fitness'))
    const golfSkillsSessionAssessments = computed(() => sessionAssessments.value.filter(a => a.category && a.category.toLowerCase() === 'practice'))

    const areFitnessRoutinesLoading = areSessionsLoading
    const arePracticeSessionsLoading = areSessionsLoading

    onMounted(async () => {
      await Promise.all([
        fetchExercises(),
        fetchSessions(),
        fetchFitnessAssessments(),
        fetchGolfAssessments(),
        fetchSessionAssessments(),
      ])
      fitnessExercises.value = exercises.value.filter(exercise => exercise.category === 'fitness')
      practiceDrills.value = exercises.value.filter(exercise => exercise.category === 'practice')
    })

    return {
      areExercisesLoading,
      fitnessExercises,
      practiceDrills,
      areFitnessRoutinesLoading,
      fitnessRoutines,
      arePracticeSessionsLoading,
      practiceSessions,
      areFitnessAssessmentsLoading,
      fitnessSessionAssessments,
      areGolfAssessmentsLoading,
      golfSkillsSessionAssessments,
      areSessionAssessmentsLoading,
      icons: {
        mdiAvTimer,
        mdiDumbbell,
        mdiGolfTee,
        mdiWeightLifter,
        mdiFileChartOutline,
      },
    }
  },
}
</script>
